<div class="mt-3">
  <button class="btn btn-primary mb-3" (click)="openFollowUpDialog()" [disabled]="!hasPermission('QuotationsAddNewPermission')">
    Add Follow up details
  </button>

  <!-- Follow Up Table -->
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Follow Up Date</th>
        <th>Next Follow Up Date</th>
        <th>Follow Up Details</th>
        <th>Follow Up Remarks</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let followUp of followUpDetails">
        <td>
          <ng-container *ngIf="followUp.followUpDate && followUp.followUpDate !== '0001-01-01T00:00:00'; else noDate">
            {{ followUp.followUpDate | date: 'dd-MM-yyyy' }}
          </ng-container>
          <ng-template #noDate>-</ng-template>
        </td>
        <td>
          <ng-container *ngIf="followUp.nextFollowUpDate && followUp.nextFollowUpDate !== '0001-01-01T00:00:00'; else noDate">
            {{ followUp.nextFollowUpDate | date: 'dd-MM-yyyy' }}
          </ng-container>
          <ng-template #noDate>-</ng-template>
        </td>
        <td>{{ followUp.followUpDetails }}</td>
        <td>{{ followUp.followUpRemarks }}</td>
        <td>
          <button class="btn btn-sm btn-warning" (click)="editFollowUp(followUp)">
            Edit
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
